import { render, staticRenderFns } from "./UkrposhtaFilter.vue?vue&type=template&id=3f8017f8&scoped=true"
import script from "./UkrposhtaFilter.vue?vue&type=script&lang=js"
export * from "./UkrposhtaFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8017f8",
  null
  
)

export default component.exports